
const mapImageURLToRootDomain = src => {
    const startIndex = src.indexOf('.net/') + 5;
    return /joybird[5678]\.imgix\.net/g.test(src)
      ? `https://joybird2.imgix.net/${src.substring(startIndex)}`
      : src;
  };

export default mapImageURLToRootDomain;
